import { useEffect } from 'react';
import { LiveScansTable } from '../components/LiveScansTable';
import { listLiveJobs } from '../api';
import { usePolling } from '../hooks/usePolling';
import { VIDEO_SCAN_SUBMITTED_EVENT } from '../../components/AppShell';

interface VideoLiveScansPageProps {
  refreshKey: number;
}

export function VideoLiveScansPage({ refreshKey }: VideoLiveScansPageProps) {
  const { data: jobs, loading, error, refresh } = usePolling(listLiveJobs, 3000, [refreshKey]);

  // Force an immediate refresh whenever the AppShell-level Generate Scan
  // modal submits, so the new job pops in instantly instead of waiting up
  // to 3 seconds for the next poll tick.
  useEffect(() => {
    const onSubmitted = () => refresh();
    window.addEventListener(VIDEO_SCAN_SUBMITTED_EVENT, onSubmitted);
    return () => window.removeEventListener(VIDEO_SCAN_SUBMITTED_EVENT, onSubmitted);
  }, [refresh]);

  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-primary-900">Live Video Scans</h1>
          <p className="text-sm text-primary-500 mt-1">
            Pending and in-progress turntable-video jobs. Refreshes every 3 seconds.
          </p>
        </div>
        {jobs && (
          <div className="text-sm text-primary-500">
            <span className="font-semibold text-primary-900">{jobs.length}</span> active
          </div>
        )}
      </div>

      {error && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          Failed to load: {error}
        </div>
      )}

      {loading && !jobs ? (
        <div className="text-sm text-primary-400">Loading…</div>
      ) : (
        <LiveScansTable jobs={jobs ?? []} onMutated={refresh} />
      )}
    </div>
  );
}
